import React, { useState, useContext } from "react";
import { Invoices } from "./Invoices";
import { PaymentMethods } from "./PaymentMethods";
import swal from "sweetalert";
import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button,
  FormGroup,
  Label,
  Input,
} from "reactstrap";
import { closeWebsocket } from "../../utils/websocketConnect";
import { useDispatch, useSelector } from "react-redux";
import { resetStateProperties } from "../../redux/slices/propertiesSlice";
import { resetStateRooms } from "../../redux/slices/roomsSlice";
import { resetStateItems } from "../../redux/slices/itemsSlice";
import {
  resetStateChat,
  setAccpetedUsers,
  setMessagesList,
  setOnlineUsersList,
  setUnReadCount,
  setUnseenMessages,
} from "../../redux/slices/chatSlice";
import { useTheme } from "../../utils/ThemeContext";
import { GlobalLoaderContext } from "../../utils/GlobalLoaderContext";
import { useHistory } from "react-router-dom";
import "./subscription.css";
import DEATH_API from "../../apis/death.api";

export const PaymentsNew = () => {
  const { setTheme } = useTheme();
  const { resetLoader } = useContext(GlobalLoaderContext);
  const [view, setView] = useState(true);
  const [showReason, setShowReason] = useState(false);
  const [reason, setReason] = useState("");
  const [otherReason, setOtherReason] = useState("");
  const [loading, setLoading] = useState(false);
  const dispatch = useDispatch();
  const history = useHistory();

  const signOut = () => {
    setTheme("light");
    dispatch(resetStateProperties());
    dispatch(resetStateRooms());
    dispatch(resetStateItems());
    dispatch(resetStateChat());
    dispatch(setUnReadCount(0));
    dispatch(setUnseenMessages([]));
    dispatch(setAccpetedUsers([]));
    dispatch(setMessagesList([]));
    dispatch(setOnlineUsersList([]));
    resetLoader();
    closeWebsocket();
    localStorage.clear();
    history.push("/login");
  };

  const handleDeleteAccountClick = () => {
    swal({
      title: "Confirm Intent",
      className: "deletion-swal",
      icon: "warning",
      content: {
        element: "div",
        attributes: {
          innerHTML: `
            <div style="text-align: center; font-family: 'Poppins', sans-serif; padding: 15px;">
              <div style="background: #FEF2F2; color: #991B1B; padding: 12px; border-radius: 10px; margin-bottom: 20px; font-size: 14px; font-weight: 500; border: 1px solid #FECACA;">
                Attention: This action is sensitive. Please verify your intent.
              </div>
              <p style="color: #4b5563; margin-bottom: 20px; font-size: 15px; line-height: 1.5;">
                To protect your data, please type the word 
                <strong style="color: #DC2C2C; font-size: 19px; display: block; margin-top: 5px; letter-spacing: 0.05em;">"Delete"</strong> 
                below to proceed.
              </p>
              <input type="text" id="confirm-delete-input" 
                style="width: 100%; padding: 14px; border: 2px solid #E5E7EB; border-radius: 12px; text-align: center; font-size: 16px; outline: none; transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1); box-shadow: 0 1px 2px rgba(0,0,0,0.05);" 
                placeholder="Type here..."
                onfocus="this.style.borderColor='#DC2C2C'; this.style.boxShadow='0 0 0 4px rgba(220, 44, 44, 0.1)';"
                onblur="this.style.borderColor='#E5E7EB'; this.style.boxShadow='0 1px 2px rgba(0,0,0,0.05)';"
              />
            </div>
          `,
        },
      },
      buttons: {
        cancel: {
          text: "Go Back",
          value: null,
          visible: true,
          className: "savebutton cancel-btn",
        },
        confirm: {
          text: "Confirm",
          value: true,
          visible: true,
          className: "savebutton delete-btn",
        },
      },
    }).then((value) => {
      if (value) {
        const inputElement = document.getElementById("confirm-delete-input");
        const inputVal = inputElement ? inputElement.value : "";
        if (inputVal === "Delete") {
          showDeletionWarning();
        } else {
          swal(
            "Wait!",
            "The confirmation text is incorrect. Please try again.",
            "error",
          );
        }
      }
    });
  };

  const showDeletionWarning = () => {
    swal({
      title: "Permanent Data Deletion",
      className: "deletion-swal",
      content: {
        element: "div",
        attributes: {
          innerHTML: `
            <div style="text-align: left; font-family: 'Poppins', sans-serif; padding: 10px 20px;">
              <h5 style="font-weight: 700; margin-bottom: 1.2rem; color: #111827; font-size: 18px; letter-spacing: -0.01em;">Are you sure you want to proceed?</h5>
              <p style="color: #4b5563; margin-bottom: 1.5rem; font-size: 14px; line-height: 1.6;">
                By confirming this request, we will initiate the process to <strong>permanently remove</strong> your account and all associated data from Asset Planet.
              </p>
              
              <div style="background: #FFF5F5; border-left: 4px solid #DC2C2C; padding: 20px; border-radius: 8px; margin-bottom: 1.5rem; box-shadow: 0 1px 3px rgba(0,0,0,0.05);">
                <p style="margin-bottom: 12px; font-size: 13px; font-weight: 800; color: #991b1b; text-transform: uppercase; letter-spacing: 0.1em;">Data to be Purged:</p>
                <ul style="color: #4b5563; padding-left: 1.5rem; font-size: 14px; line-height: 1.8; margin: 0;">
                  <li><strong style="color: #111827;">Financial Data:</strong> All goals, linked accounts, and transactions.</li>
                  <li><strong style="color: #111827;">Documents:</strong> All uploaded files in the "Important Documents" module.</li>
                </ul>
              </div>

              <div style="background: #F9FAFB; border: 1px solid #E5E7EB; padding: 15px; border-radius: 10px;">
                <p style="color: #6B7280; font-size: 13px; line-height: 1.6; margin: 0; font-style: italic;">
                  <strong style="color: #374151;">Note:</strong> Your account deactivates immediately. Data is purged after 30 days. No secondary backups are maintained.
                </p>
              </div>
            </div>
          `,
        },
      },
      icon: "warning",
      dangerMode: true,
      buttons: {
        cancel: {
          text: "Keep My Account",
          value: "cancel",
          visible: true,
          className: "savebutton cancel-btn",
        },
        confirm: {
          text: "Delete My Data Permanently",
          value: "delete",
          visible: true,
          className: "savebutton delete-btn",
        },
      },
    }).then((value) => {
      if (value === "delete") {
        setShowReason(true);
      } else if (value === "cancel") {
        swal("Cancelled", "Your account is safe :)", "info");
      }
    });
  };

  const handleReasonSubmit = async () => {
    try {
      if (!reason) {
        swal("Oops!", "Please select a reason for leaving.", "warning");
        return;
      }

      setLoading(true);
      if (reason === "Technical") {
        console.log("LOG: Technical issue alert sent to Slack/Jira.");
      }

      setShowReason(false);
      const payload = {
        reason: reason === "Other" ? otherReason : reason,
      };
      console.log("Account Deletion Payload:", payload);
      const response = await DEATH_API.deleteUserAccount(payload);
      console.log("Account Deletion Response:", response);
      if (response && response.status === 200) {
        console.log("Account deletion initiated successfully.");
        swal({
          title: "Request Received",
          text: "We've initiated your account deactivation. You will be logged out in a moment. Check your email for confirmation.",
          icon: "success",
          timer: 3000,
          buttons: false,
        }).then(() => {
          console.log("Final Deletion Submit:", { reason, otherReason });
          signOut();
          // Execute logout/cleanup here
        });
      } else {
        console.error("Account deletion failed:", response);
        swal(
          "Error",
          "There was an issue processing your request. Please try again later.",
          "error",
        );
        return;
      }
    } catch (error) {
      console.error("Error submitting account deletion request:", error);
      swal(
        "Error",
        "Something went wrong while processing your request. Please try again.",
        "error",
      );
    } finally {
      setLoading(false);
    }
  };

  const reasonOptions = [
    { label: "The app was too difficult to use.", value: "UX/UI Issues" },
    { label: "I didn't find the features I needed.", value: "Value Gap" },
    { label: "I had trouble linking my accounts.", value: "Technical" },
    { label: "The subscription is too expensive.", value: "Cost" },
    { label: "My financial situation has changed.", value: "Life Event" },
    { label: "I'm not comfortable sharing my data.", value: "Privacy" },
    { label: "Other (Please specify)", value: "Other" },
  ];

  return (
    <React.Fragment>
      <div
        style={{
          paddingInline: "2rem",
          margin: "1rem 0rem",
          display: "flex",
          gap: "10px",
        }}
      >
        <button
          className="savebutton"
          style={{
            textAlign: "center",
            fontSize: "14px",
            fontWeight: "600",
            padding: "12px 20px",
            opacity: view ? "1" : "0.3",
            transition: "opacity 0.2s",
          }}
          onClick={() => setView(true)}
        >
          View Invoices
        </button>
        <button
          className="savebutton"
          style={{
            textAlign: "center",
            fontSize: "14px",
            fontWeight: "600",
            padding: "12px 20px",
            opacity: view ? "0.3" : "1",
            transition: "opacity 0.2s",
          }}
          onClick={() => setView(false)}
        >
          View Payment Methods
        </button>
        <button
          className="savebutton delete-btn"
          style={{
            textAlign: "center",
            fontSize: "14px",
            fontWeight: "600",
            padding: "12px 20px",
          }}
          onClick={handleDeleteAccountClick}
        >
        {loading ? (
              <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                <span className="spinner-border spinner-border-sm" />
                Processing...
              </div>
            ) : (
          "Delete My Account"
          )}
        </button>
      </div>

      {view ? <PaymentMethods /> : <Invoices />}

      {/* Reason for Leaving Modal - Beautified */}
      <Modal
        isOpen={showReason}
        toggle={() => setShowReason(false)}
        centered
        className="premium-modal"
        backdrop="static"
      >
        <ModalHeader
          className="delete-modal-header"
          toggle={() => setShowReason(false)}
        >
          <div className="delete-modal-title">We're sorry to see you go</div>
        </ModalHeader>
        <ModalBody style={{ padding: "0 2.5rem 2rem" }}>
          <p
            style={{
              color: "#6B7280",
              marginBottom: "1.5rem",
              fontSize: "14px",
              lineHeight: "1.5",
            }}
          >
            Your feedback is invaluable. Please let us know why you're leaving
            so we can continue to improve.
          </p>
          <div style={{ display: "flex", flexDirection: "column", gap: "2px" }}>
            {reasonOptions.map((opt) => (
              <label
                key={opt.value}
                className={`reason-option-label ${reason === opt.value ? "reason-option-active" : ""}`}
              >
                <input
                  type="radio"
                  name="reason"
                  value={opt.value}
                  checked={reason === opt.value}
                  onChange={(e) => setReason(e.target.value)}
                  style={{
                    marginRight: "16px",
                    width: "18px",
                    height: "18px",
                    cursor: "pointer",
                    accentColor: "#DC2C2C",
                  }}
                />
                <span style={{ fontSize: "15px", letterSpacing: "-0.01em" }}>
                  {opt.label}
                </span>
              </label>
            ))}
          </div>

          {reason === "Other" && (
            <div
              style={{
                marginTop: "1.5rem",
                animation: "fadeIn 0.4s cubic-bezier(0.16, 1, 0.3, 1)",
              }}
            >
              <Label
                for="otherText"
                style={{
                  fontSize: "13px",
                  fontWeight: "700",
                  color: "#374151",
                  marginBottom: "8px",
                  display: "block",
                  textTransform: "uppercase",
                  letterSpacing: "0.05em",
                }}
              >
                Tell us more
              </Label>
              <Input
                type="textarea"
                id="otherText"
                maxLength={250}
                value={otherReason}
                onChange={(e) => setOtherReason(e.target.value)}
                placeholder="How could we have served you better?"
                style={{
                  borderRadius: "12px",
                  border: "1px solid #E5E7EB",
                  minHeight: "120px",
                  fontSize: "14px",
                  padding: "12px 16px",
                  resize: "none",
                  boxShadow: "inset 0 2px 4px 0 rgba(0, 0, 0, 0.05)",
                  outline: "none",
                  transition: "all 0.2s",
                }}
                onFocus={(e) => (e.target.style.borderColor = "#DC2C2C")}
                onBlur={(e) => (e.target.style.borderColor = "#E5E7EB")}
              />
              <div
                style={{
                  textAlign: "right",
                  fontSize: "12px",
                  color: "#9CA3AF",
                  marginTop: "6px",
                  fontWeight: "500",
                }}
              >
                {otherReason.length} / 250
              </div>
            </div>
          )}
        </ModalBody>
        <ModalFooter
          style={{ borderTop: "none", padding: "0 2.5rem 2.5rem", gap: "12px" }}
        >
          <Button
            className="savebutton cancel-btn"
            style={{
              padding: "12px 24px",
              fontWeight: "600",
              fontSize: "14px",
            }}
            onClick={() => setShowReason(false)}
          >
            Cancel
          </Button>
          <Button
            className="savebutton delete-btn"
            style={{
              padding: "12px 24px",
              fontWeight: "600",
              fontSize: "14px",
            }}
            onClick={handleReasonSubmit}
            disabled={
              loading || !reason || (reason === "Other" && !otherReason.trim())
            }
          >
            {loading ? (
              <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                <span className="spinner-border spinner-border-sm" />
                Processing...
              </div>
            ) : (
              "Confirm & Deactivate"
            )}
          </Button>
        </ModalFooter>
      </Modal>
    </React.Fragment>
  );
};
